import { FrontendPageContent } from "@/components/frontend/FrontendPageContent";
import { Outlet } from "react-router";

const FrontEndSettings = () => {
    return (
        <FrontendPageContent className="p-4">
            <Outlet />
        </FrontendPageContent>
    );
};

export default FrontEndSettings;
